import { Directive,ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
 selector: '[propertyKeyword]',
 providers: [NgModel]
})
export class PropertyKeywordDirective {

    constructor(public ref: ElementRef) { }

    @HostListener('input', ['$event']) lettersAndSpacesOnly(event) {

        let regex = /^[a-zA-Z0-9]*$/
        let replaceRegex = /[^a-zA-Z0-9]+/
        let str = event.target.value

        // allow letters and spaces only.
        if(!regex.test(event.key)){
            str = str.replace(replaceRegex, "") 
            this.ref.nativeElement.value = str
            event.preventDefault()
        }

    }

    @HostListener('input', ['$event']) replaceInvalidCharacters(event) {

        let replaceRegex = /[^a-zA-Z0-9]+/
        let str = event.target.value.replace(replaceRegex, "")
        event.target.value = str

    }
}